import './App.css';
import Header from './Components/Header';
import MemeSection from './Components/MemeSection';

function App() {
  return (
    <>
      <Header/>
      <MemeSection/>
    </>
  );
}

export default App;
